import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {DialogTitle, TextField} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles(() => ({
  root: {}
}));
const titles = {
  "1" : "Add New User",
  "2" : "Edit New User",
  "3" : "Reset Password"
}
const AddUser = props => {
  const { className, ...rest } = props;
  const [open, setOpen] = React.useState(true);
  const theme = useTheme();
  const [userobj, setUserobj] = React.useState(props.userobj ? props.userobj : {});
  const [values, setValues] = React.useState({
  });
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('sm');
  const classes = useStyles();
  const handleSave = () => {
    props.onUpdate(userobj)
  };
  const handleinputchange = type => e => {
    setUserobj({...userobj,[type]:e.target.value})
  };
  const handleClose = () => {
    setOpen(false);
    props.onDismiss()
  };
  const handleoptionchange = type => (event, value) => {

    setUserobj(userobj => ({
      ...userobj,
      [type]: value
    }));
  }
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{titles[props.viewtype]}</DialogTitle>
        <DialogContent>
        {props.viewtype == 1 || props.viewtype == 2 ? <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            value={userobj ? userobj.name : null}
                            autoComplete="off"
                            id="name"
                            name="name"
                            onChange={handleinputchange('name')}
                            label="Name"
                          /> : null}
        {props.viewtype == 1 || props.viewtype == 2 ? <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            value={userobj ? userobj.mobile : null}
                            autoComplete="off"
                            id="mobile"
                            name="mobile"
                            onChange={handleinputchange('mobile')}
                            label="Mobile"
                          /> : null}
        {props.viewtype == 1 || props.viewtype == 2 ? <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            value={userobj ? userobj.username : null}
                            autoComplete="off"
                            id="username"
                            name="username"
                            onChange={handleinputchange('username')}
                            label="Username"
                          /> : null}
                {props.viewtype == 1 || props.viewtype == 2 ?            <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={props.masterroles == null ? [] : props.masterroles}
                  margin="dense"
                  fullWidth
                  disabled={false}
                  value={userobj && userobj.user_roles ? userobj.user_roles : []}
                  onChange={handleoptionchange('user_roles')}
                 
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} label={"Choose Role"} fullWidth margin="dense" variant="outlined" />}
                />  : null}
                        {props.viewtype == 1 || props.viewtype == 3 ?   <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="password"
                            autoComplete="off"
                            id="password"
                            name="password"
                            onChange={handleinputchange('password')}
                           label="Password"
                          />  : null}
        </DialogContent>
        <DialogActions>
          <Button  onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary" autoFocus>
           {props.viewtype == 2 ? "Update" : props.viewtype == 3 ? "Reset" : "Add"

           } 
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

AddUser.propTypes = {
  className: PropTypes.string
};

export default AddUser;
